import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';

@Component({
  selector: 'app-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.scss']
})
export class BarcodeScannerComponent {
  @ViewChild('scanner') scanner!: ZXingScannerComponent;

  // Entrées pour piloter l'état depuis le parent
  @Input() isProcessing = false;
  @Input() formats: BarcodeFormat[] = [
    BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, 
    BarcodeFormat.CODE_128, BarcodeFormat.UPC_A
  ];

  // Sorties pour communiquer avec le parent
  @Output() scanSuccess = new EventEmitter<string>();
  @Output() permissionError = new EventEmitter<boolean>();

  availableDevices: MediaDeviceInfo[] = [];
  currentDevice: MediaDeviceInfo | undefined;
  hasPermission = true;
  torchEnabled = false;
  torchAvailable = false;

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices.filter(device => {
      const label = device.label.toLowerCase();
      const isFront = label.includes('front') || label.includes('user') || label.includes('avant');
      const isZoom = label.includes('tele') || label.includes('zoom') || label.includes('2x');
      return !isFront && !isZoom;
    });

    if (this.availableDevices.length > 0) {
      this.selectBestCamera();
    }
  }

  private selectBestCamera(): void {
    // Priorité à la caméra "wide" (principale)
    const main = this.availableDevices.find(d => 
      d.label.toLowerCase().includes('main') || 
      (d.label.toLowerCase().includes('wide') && !d.label.toLowerCase().includes('ultra'))
    );
    this.currentDevice = main || this.availableDevices[0];
  }

  onCodeResult(result: string): void {
    if (!this.isProcessing && result) {
      this.scanSuccess.emit(result);
    }
  }

  onHasPermission(has: boolean): void {
    this.hasPermission = has;
    if (!has) this.permissionError.emit(false);
  }

  switchCamera(): void {
    const idx = this.availableDevices.findIndex(d => d.deviceId === this.currentDevice?.deviceId);
    this.currentDevice = this.availableDevices[(idx + 1) % this.availableDevices.length];
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }
}